export default __webpack_public_path__ + "DS.01f2024b.png";